import React, { useState, useEffect } from "react";
import { Container, Grid, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getData } from "../../../components/utilities/UtilityFunctions";
import FactionBreakdownBarChart from "./EventStats/FactionBreakdownBarChart";
import { userDisplayName } from "./EventFunctions";
import FactionRankings from "../../stats/components/FactionRankings";
import AttackDefendStats from "../../stats/components/AttackDefendStats";

export default function EventStats(props) {
  const { event } = props;
  const theme = useTheme();

  const [loading, setLoading] = useState(true);
  const [players, setPlayers] = useState([]);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchPlayers = async () => {
      const returnArray = [];

      const apiData = await getData(`/events/${event?.id}/players`);

      if (apiData && apiData?.active?.length) {
        returnArray.push(...apiData.active);
      }

      if (!returnArray || !returnArray?.length) {
        return [];
      }

      returnArray?.sort((a, b) => {
        var nameA = userDisplayName(
          a?.user?.firstName,
          a?.user?.lastName
        ).toLowerCase();
        var nameB = userDisplayName(
          b?.user?.firstName,
          b?.user?.lastName
        ).toLowerCase();
        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;
        return 0;
      });

      return returnArray;
    };

    const fetchStats = async () => {
      let apiData = await getData("/stats", {
        queryStringParameters: {
          eventId: event?.id
        }
      });
      if (!apiData?.leaderboard) {
        apiData.leaderboard = {
          label: "Faction",
          labelPlural: "Factions",

          rows: apiData?.factions || apiData?.armies || apiData?.subFactions
        };
        if (apiData?.armies?.length) {
          apiData.leaderboard.childLabel = "Army";
          apiData.leaderboard.childLabelPlural = "Armies";
        }
      }
      if (apiData?.leaderboard.rows?.length) {
        for (let record of apiData.leaderboard.rows) {
          if (record.position === undefined) {
            record.position = record.rank;
          }
        }
      }

      setStats(apiData);
      return;
    };

    const loadData = async () => {
      setLoading(true);
      const playersData = await fetchPlayers();
      setPlayers(playersData);
      await fetchStats();

      setLoading(false);
    };

    if (event?.id) {
      loadData();
    }
  }, [event?.id]);

  if (loading) {
    return (
      <Container
        maxWidth="lg"
        sx={{
          pt: 2,
          pb: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px"
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container
      maxWidth="lg"
      sx={{
        pt: 2,
        pb: 2
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FactionBreakdownBarChart players={players} theme={theme} />
        </Grid>
      </Grid>

      {stats?.leaderboard?.rows?.length > 0 ? (
        <Grid
          container
          spacing={2}
          sx={{
            pt: 2
          }}
        >
          <Grid item xs={12}>
            <FactionRankings
              data={{ rows: stats?.leaderboard?.rows }}
              label={
                stats?.leaderboard?.label || stats?.gameSystem?.factionLabel
              }
              theme={theme}
              childRecordType={stats?.leaderboard?.childLabel?.toLowerCase()}
              childLabel={stats?.leaderboard?.childLabelPlural}
            />
          </Grid>
        </Grid>
      ) : (
        <></>
      )}

      {stats?.priorityTurn !== undefined ? (
        <Grid
          container
          spacing={2}
          sx={{
            pt: 2
          }}
        >
          <Grid item xs={12}>
            <AttackDefendStats
              rows={[
                stats?.priorityTurn?.first
                  ? {
                      ...stats?.priorityTurn?.first,
                      label: stats?.priorityTurn?.first?.label || "Attacker"
                    }
                  : undefined,
                stats?.priorityTurn?.second
                  ? {
                      ...stats?.priorityTurn?.second,
                      label: stats?.priorityTurn?.second?.label || "Defender"
                    }
                  : undefined
              ].filter((el) => el !== undefined)}
              label={stats?.priorityTurn?.label || "Attacker / Defender"}
              theme={theme}
            />
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </Container>
  );
}
